import * as THREE from 'three';

export default class SubtractiveColour {
	constructor() {
		this.blockName = "subtractive-colour";
		this.curveNames = ["Subtractive-Colour-Gain-Y", "Subtractive-Colour-C", "Subtractive-Colour-M", "Subtractive-Colour-Y"];
		this.opacity = {
			minValue: 0,
			maxValue: 100,
		};
	}

	addBlock(blockNum = lutify.blocks.length) {
		UI.createAdjustmentBlockTemplate(this.blockName, blockNum);
		let element = UI.getAdjustmentBlock(blockNum);

		UI.removeBlockBlendingModes($(element));

		// $(element).find('.control-selector__items-container > span').on('click', (e, animate) => this.controlSelection(e.currentTarget, animate));
		$(element)
			.find(".btn-reset-block")
			.off("click")
			.on("click", _ => this.resetBlock($(element)));
		$(element)
			.find('.block-controls-container[data-control="sliders"] .slider-control')
			.on("dblclick", e => this.resetVerticalSlider($(e.currentTarget)));

		$(element)
			.find(".expand_options")
			.trigger("click", [false]);

		$(element)
			.find('.block-controls-container[data-control="sliders"] .slider-control')
			.on("input", e => this.verticalSliderHandler($(e.currentTarget)));
		$(element)
			.find('.block-controls-container[data-control="sliders"] .slider-input-control')
			.on("change", e => this.verticalSliderInputHandler($(e.currentTarget)));

		$(element)
			.find(".btn-linked-values")
			.on("click", e => {
				e.currentTarget.classList.toggle("--active");
				lutify.getActiveBlock().linkedValues = !lutify.getActiveBlock().linkedValues;
			});

		$(element).find(".opacity_slider").on("input", () => this.opacitySliderHandler($(element)));
		$(element).find(".opacity-input").on("change", () => this.opacityInputHandler($(element)));

		UI.initKnob(element);

		blocks.add({
			name: "subtractiveColour",
			passes: this.addPasses(),
			blockNum,
			blendingMode: 0,
			blendingModeName: "Normal",
			opacity: 100,
			curves: [],
			values: {
				sliders: {
					gainY: 0,
					C: 0,
					M: 0,
					Y: 0,
				},
			},
			linkedValues: false,
			startValues: {
				gainY: 0,
				C: 0,
				M: 0,
				Y: 0,
			},
		});

		this.slidersInit($(element));
		blocks.createCurves(this.curveNames, blockNum);
	}

	addPasses() {
		let RGBPositivePass = gpu.createSubtractiveColourPass();
		gpu.addPassToComposer(RGBPositivePass, "toMiddle");

		let RGBNegativePass = gpu.createCurveShaderPass();
		gpu.addPassToComposer(RGBNegativePass, "toMiddle");

		let gainYPass = gpu.createCurveShaderPass("gain-Y");
		gpu.addPassToComposer(gainYPass, "toMiddle");

		return [RGBPositivePass, RGBNegativePass, gainYPass];
	}

	slidersInit($element) {
		$element.find('.block-controls-container[data-control="sliders"] .slider-control').slider({
			orientation: "vertical",
			width: 1,
			range: "min",
			min: -1,
			max: 1,
			step: 0.001,
			value: 0,
			start: (event, ui) => this.setStartValues(event, ui),
			change: (event, ui) => {
				if (lutify.getActiveBlock().sliding) return;
				this.verticalSliderHandler(event, ui);
			},
			slide: (event, ui) => {
				if (lutify.getActiveBlock().sliding) return;
				this.verticalSliderHandler(event, ui);
			},
		});

		$element.find('.block-controls-container[data-control="sliders"] .slider-control').each((index, sliderControl) => {
			let html = document.createElement("div");
			html.setAttribute("class", "slider-control-fill");
			$(sliderControl).append(html);
		});
	}

	setStartValues() {
		lutify.getActiveBlock().startValues = { ...lutify.getActiveBlock().values.sliders };
	}

	verticalSliderHandler(event, ui) {
		lutify.getActiveBlock().sliding = true;
		let $sliderControlElement = $(event.target);
		let control = $sliderControlElement.data("control");
		let passIndex = $sliderControlElement.data("pass-index");

		lutify.getActiveBlock().values.sliders[control] = ui.value;
		lutify.getActiveBlock().activePassIndex = passIndex;
		lutify.getActiveBlock().passes[passIndex].enabled = true;

		if (["C", "M", "Y"].includes(control)) {
			// linked values
			if (lutify.getActiveBlock().linkedValues) {
				Object.keys(lutify.getActiveBlock().values.sliders).forEach(key => {
					if (!["gainY", control].includes(key)) {
						let value = ui.value - lutify.getActiveBlock().startValues[control] + lutify.getActiveBlock().startValues[key];
						if (value > 1) value = 1;
						else if (value < -1) value = -1;

						lutify.getActiveBlock().values.sliders[key] = value;
						let linkedSliderElement = $(event.target)
							.closest(".control-container")
							.find(`.slider-control[data-control="${key}"]`);
						linkedSliderElement.slider("value", value);

						this.updateSliderUI(linkedSliderElement, value);

						let linkedSliderInput = $(event.target)
							.closest(".control-container")
							.find(`.slider-input-control[data-control="${key}"]`);
						linkedSliderInput.val(value);
					}
				});
			}

			let valueC = lutify.getActiveBlock().values.sliders.C;
			let valueM = lutify.getActiveBlock().values.sliders.M;
			let valueY = lutify.getActiveBlock().values.sliders.Y;

			this.callCMYpositive(valueC, valueM, valueY);

			passIndex = $sliderControlElement.data("negative-pass-index");
			lutify.getActiveBlock().activePassIndex = passIndex;
			lutify.getActiveBlock().passes[passIndex].enabled = true;

			this.liftRGBCurve([valueC, valueM, valueY]);
		} else {
			// curve Y
			this.gainYCurve(lutify.getActiveBlock().values.sliders.gainY);
		}

		let $sliderInputElement = $sliderControlElement.closest(".control-container").find(`.slider-input-control[data-control="${control}"]`);
		$sliderInputElement.val(ui.value);

		this.updateSliderUI($(event.target).closest(".slider-control"), ui.value);
		blocks.checkSwitchHandler($(event.target).closest(".adjustment-block"));

		lutify.getActiveBlock().sliding = false;
	}

	verticalSliderInputHandler($sliderInputElement) {
		let control = $sliderInputElement.data("control");

		lutify.getActiveBlock().values.sliders[control] = $sliderInputElement.val();

		let $sliderControlElement = $sliderInputElement.closest(".control-container").find(`.slider-control[data-control="${control}"]`);
		$sliderControlElement.slider("value", $sliderInputElement.val());

		blocks.checkSwitchHandler($sliderInputElement.closest(".adjustment-block"));
	}

	gainYCurve(gainVal) {
		let curve = lutify.getActiveBlock().curves[0].colorCurve;
		curve.points = [];

		if (gainVal > 0) {
			curve.points.push({ x: 0, y: 0.0 });
			curve.points.push({ x: 1.0 - gainVal * 0.003921 * 128, y: 1.0 });
		} else {
			curve.points.push({ x: 0, y: 0 });
			curve.points.push({ x: 1.0, y: 1.0 - Math.abs(gainVal) * 0.003921 * 128 });
		}

		curve.draw();
		curve.updateValues();
		this.callGPUGainY(curve.rgb);
	}

	liftRGBCurve(liftValues) {
		let curves = [];
		curves[0] = lutify.getActiveBlock().curves[1].colorCurve;
		curves[1] = lutify.getActiveBlock().curves[2].colorCurve;
		curves[2] = lutify.getActiveBlock().curves[3].colorCurve;

		liftValues.forEach((liftValue, index) => {
			if (liftValue >= 0) liftValue = 0;
			liftValue = Math.abs(liftValue);
			curves[index].points = [];

			curves[index].points.push({ x: 0.0, y: 0.0 + liftValue * 0.003921 * 128 });
			curves[index].points.push({ x: 1.0, y: 1.0 });

			curves[index].draw();
			curves[index].updateValues();
		});

		this.callGPULiftRGB(curves[0].rgb, curves[1].rgb, curves[2].rgb);
	}

	callGPUGainY(points) {
		let curveTexture = gpu.pointsToCurve(points);
		let passIndex = lutify.getActiveBlock().activePassIndex;

		lutify.getActiveBlock().passes[passIndex].uniforms["map"].value = curveTexture;
		gpu.render();
	}

	callGPULiftRGB(pointsR, pointsG, pointsB) {
		let curveTexture = gpu.RGBPointsToCurve(pointsR, pointsG, pointsB);
		let passIndex = lutify.getActiveBlock().activePassIndex;

		lutify.getActiveBlock().passes[passIndex].uniforms["map"].value = curveTexture;
		gpu.render();
	}

	callCMYpositive(valueC, valueM, valueY) {
		let passIndex = lutify.getActiveBlock().activePassIndex;

		if (valueC < 0) valueC = 0;
		if (valueM < 0) valueM = 0;
		if (valueY < 0) valueY = 0;

		lutify.getActiveBlock().passes[passIndex].uniforms.CMYK.value = new THREE.Vector4(valueC, valueM, valueY, 0);
		gpu.render();
	}

	resetBlock($element) {
		lutify.getActiveBlock().linkedValues = false;
		$element.find(".btn-linked-values").removeClass("--active");

		let $sliderInputControls = $element.find(".slider-input-control");
		$sliderInputControls.each(function() {
			$(this).val($(this).data("default-value"));
		});
		$sliderInputControls.trigger("change");
		lutify.getActiveBlock().passes.forEach(pass => (pass.enabled = false));
	}

	resetVerticalSlider($slider) {
		$slider.slider("value", 0);

		let control = $slider.data("control");
		let passIndex = $slider.data("pass-index");

		if (control == "gainY") {
			lutify.getActiveBlock().passes[passIndex].enabled = false;
		} else if (
			lutify.getActiveBlock().values.sliders.C == 0 &&
			lutify.getActiveBlock().values.sliders.M == 0 &&
			lutify.getActiveBlock().values.sliders.Y == 0
		) {
			lutify.getActiveBlock().passes[passIndex].enabled = false;

			let negativePassIndex = $slider.data("negative-pass-index");
			lutify.getActiveBlock().passes[negativePassIndex].enabled = false;
		}
	}

	updateSliderUI($slider, sliderValue) {
		let $sliderControlElementHeight = $slider.height();
		let sliderControlFillHeight = Math.abs(($sliderControlElementHeight * sliderValue) / 2);
		let $sliderControlFillElement = $slider.find(".slider-control-fill");
		$sliderControlFillElement.css("height", `${sliderControlFillHeight}px`);

		if (sliderValue > 0) {
			$sliderControlFillElement.css({
				bottom: "50%",
				top: "initial",
			});
		} else if (sliderValue < 0) {
			$sliderControlFillElement.css({
				top: "50%",
				bottom: "initial",
			});
		}
	}

	opacitySliderHandler($element) {
		let opacityValue = $element.find(".opacity_slider").val();
		let calcOpacityValue = opacityValue * 0.01;

		$element.find(".opacity-input").val(opacityValue);

		lutify.getActiveBlock().opacity = opacityValue;
		lutify.getActiveBlock().passes.forEach(pass => {
			pass.uniforms.opacity.value = calcOpacityValue;
		})

		gpu.render();
	}

	opacityInputHandler($element) {
		let opacityValue = $element.find(".opacity-input").val();
		let opacitySlider = $element.find(".opacity_slider");

		if (opacityValue > this.opacity.maxValue) opacityValue = this.opacity.maxValue;
		if (opacityValue < this.opacity.minValue) opacityValue = this.opacity.minValue;

		opacitySlider.val(opacityValue);
		opacitySlider.trigger("input");
	}

	applyChanges($block, values, blockData) {
		$block.find(`.slider-input-control[data-control="gainY"]`).val(values.sliders.gainY);
		$block.find(`.slider-input-control[data-control="C"]`).val(values.sliders.C);
		$block.find(`.slider-input-control[data-control="M"]`).val(values.sliders.M);
		$block.find(`.slider-input-control[data-control="Y"]`).val(values.sliders.Y);

		$block.find('.block-controls-container[data-control="sliders"] .slider-input-control').trigger("change");

		if ('opacity' in blockData) {
			$block.find(".opacity-input").val(parseInt(blockData.opacity));
			$block.find(".opacity-input").trigger("change");
		}
	}
}
